import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { formatValidationErrors } from '../common/utils/getApiReducer';
import { updateMovementSpecialistProfile } from './actions';
import { selectActiveMovementSpecialist } from './selectors';
import MovementSpecialistEditForm from './MovementSpecialistEditForm';
import Breadcrumb from '../common/components/Breadcrumb';
import dataUrlToFile from '../common/utils/dataUrlToFile';
import cloneDeep from 'lodash/cloneDeep';

class MovementSpecialistEditPage extends Component {
  static propTypes = {
    activeMovementSpecialist: PropTypes.object,
    movementSpecialists: PropTypes.object,
    dispatch: PropTypes.func,
    initialValues: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      addChapterModalVisible: false,
      clearOrigProfileImage: false,
      clearOrigHeaderImage: false,
      editing: false,
    };
  }

  toggleEdit = () => {
    this.setState(state => ({
      editing: !state.editing,
      clearOrigProfileImage: false,
      clearOrigHeaderImage: false,
    }));
  };

  onEditMovementSpecialistSubmit = values => {
    const { dispatch, activeMovementSpecialist } = this.props;
    const { clearOrigProfileImage, clearOrigHeaderImage } = this.state;
    const submitValues = cloneDeep(values);

    if (submitValues.profile_image) {
      submitValues.profile_image = dataUrlToFile(
        submitValues.profile_image.imageResult,
        submitValues.profile_image.imageFilename
      );
    }

    if (!clearOrigProfileImage) {
      submitValues.profile_image_id = activeMovementSpecialist.get('profile_image_id');
    }

    if (submitValues.header_image) {
      submitValues.header_image = dataUrlToFile(
        submitValues.header_image.imageResult,
        submitValues.header_image.imageFilename
      );
    }

    if (!clearOrigHeaderImage) {
      submitValues.header_image_id = activeMovementSpecialist.get('header_image_id');
    }

    return dispatch(
      updateMovementSpecialistProfile(activeMovementSpecialist.get('user_id'), submitValues)
    ).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.setState({ editing: false });
      }
    });
  };

  removeProfileImage = () => {
    this.setState(state => ({
      clearOrigProfileImage: true,
    }));
  };

  removeHeaderImage = () => {
    this.setState(state => ({
      clearOrigHeaderImage: true,
    }));
  };

  render() {
    const { activeMovementSpecialist, initialValues, location } = this.props;
    const { clearOrigProfileImage, clearOrigHeaderImage, editing } = this.state;

    const breadcrumbs = [
      {
        label: 'Movement Specialists',
        to: `/movement-specialists${location.search}`,
      },
      {
        label: activeMovementSpecialist.get('name'),
        to: null,
      },
    ];

    return (
      <div className="admin-paper">
        <div className="admin-paper__header">
          <Breadcrumb crumbs={breadcrumbs} />
        </div>
        {editing ? (
          <MovementSpecialistEditForm
            clearOrigProfileImage={clearOrigProfileImage}
            clearOrigHeaderImage={clearOrigHeaderImage}
            initialValues={initialValues}
            movementSpecialist={activeMovementSpecialist}
            onSubmit={this.onEditMovementSpecialistSubmit}
            onCancel={this.toggleEdit}
            removeProfileImage={this.removeProfileImage}
            removeHeaderImage={this.removeHeaderImage}
          />
        ) : (
          <div>
            <div className="admin-paper__edit-content" key="movementSpecialist-info">
              <div className="admin-paper__edit-content__row">
                <p>Name</p>
                <span>{activeMovementSpecialist.get('name')}</span>
              </div>
              <div className="admin-paper__edit-content__row">
                <p>Hidden?</p>
                <span>{activeMovementSpecialist.get('hidden') ? 'Yes' : 'No'}</span>
              </div>
              <div className="admin-paper__edit-content__row">
                <p>Biography</p>
                <span>{activeMovementSpecialist.get('biography')}</span>
              </div>
              <div className="admin-paper__edit-content__row">
                <p>Location</p>
                <span>{activeMovementSpecialist.get('location_long')}</span>
              </div>
              <div className="admin-paper__edit-content__row">
                <p>Availability</p>
                <span>{activeMovementSpecialist.get('availability')}</span>
              </div>
              <div className="admin-paper__edit-content__row">
                <div className="admin-paper__edit-content__upload">
                  <p>Profile Image</p>
                  {activeMovementSpecialist.getIn(['profileImage', 'location']) ? (
                    <div
                      className="admin__image-preview"
                      style={{
                        backgroundImage: `url(${activeMovementSpecialist.getIn(['profileImage', 'location'])})`,
                      }}
                    />
                  ) : (
                    <div className="admin__image__placeholder image__placeholder">No Image</div>
                  )}
                </div>
                <div className="admin-paper__edit-content__upload">
                  <p>Header Image</p>
                  {activeMovementSpecialist.getIn(['headerImage', 'location']) ? (
                    <div
                      className="admin__image-preview"
                      style={{
                        backgroundImage: `url(${activeMovementSpecialist.getIn(['headerImage', 'location'])})`,
                      }}
                    />
                  ) : (
                    <div className="admin__image__placeholder image__placeholder">No Image</div>
                  )}
                </div>
              </div>
              <div className="admin-paper__edit-button">
                <button className="button" onClick={this.toggleEdit}>
                  Edit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  const activeMovementSpecialist = selectActiveMovementSpecialist(state.ms.profiles, ownProps.match.params.id);

  return {
    activeMovementSpecialist,
    initialValues: activeMovementSpecialist
      ? {
          availability: activeMovementSpecialist.get('availability'),
          biography: activeMovementSpecialist.get('biography'),
          hidden: activeMovementSpecialist.get('hidden'),
          latitude: activeMovementSpecialist.get('latitude'),
          location: activeMovementSpecialist.get('location_long'),
          location_long: activeMovementSpecialist.get('location_long'),
          location_short: activeMovementSpecialist.get('location_short'),
          longitude: activeMovementSpecialist.get('longitude'),
          name: activeMovementSpecialist.get('name'),
        }
      : null,
  };
})(MovementSpecialistEditPage);



// WEBPACK FOOTER //
// ./src/movement-specialists/MovementSpecialistEditPage.js